// extracted by mini-css-extract-plugin
export var csatScore = "_jt-5";
export var header = "_jt-1";
export var panelWrapper = "_jt-2";
export var postPreview = "_jt-3";
export var rightContent = "_jt-0";
export var wrappingText = "_jt-4";